<template>
  <layout-main-inner title="合伙人业绩明细">
    <template slot="title">
      <el-form
        label-width="90px"
        :inline="true"
        class="margin-botton-0">
        <el-form-item label="姓名：">{{ baseInfo.agentName }}</el-form-item>
        <el-form-item label="手机号：">{{ baseInfo.agentPhone }}</el-form-item>
        <el-form-item label="加入时间：">{{ baseInfo.updatedTime | dateformat("YYYY年MM月DD日") }}</el-form-item>
      </el-form>
    </template>
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">历史业绩</template>
      <!-- <el-form label-width="80px"
        class="margin-botton-0">
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名：">{{baseInfo.agentName}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号：">{{baseInfo.agentPhone}}</el-form-item>
          </el-col>
        </el-row>
        <summary-list :list="total" />
      </el-form> -->
      <summary-list :list="total" />
    </layout-card-wrap>
    <layout-card-wrap
      hasHeaderSlot
      class="custom-class"
      style="margin-top:15px">
      <template slot="title">
        {{ month | dateformat('YYYY年MM月') }}业绩
        <el-tag
          v-if="commissionInfo.isSettled === 1"
          type="success">已结算</el-tag>
        <el-tag
          v-else
          type="warning">未结算</el-tag>
        <el-tag
          v-if="commissionInfo.cleaningFlag === 1"
          type="success">已提现</el-tag>
        <el-tag
          v-else
          type="warning">未提现</el-tag>
      </template>
      <template slot="form">
        <el-date-picker
          v-model="month"
          type="month"
          :clearable="false"
          :picker-options="pickerOptions"
          placeholder="选择月"
          @change="onMonthChange">
        </el-date-picker>
        <el-button-group style="margin-left:10px">
          <el-button
            type="primary"
            :disabled="disabledDate"
            icon="el-icon-arrow-left"
            @click="preMonth">上月</el-button>
          <el-button
            type="primary"
            :disabled="disabledDate1"
            @click="nextMonth">下月<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </el-button-group>
      </template>
      <summary-list
        :list="commission"
        :span="8" />
      <template v-if="orders.length > 0">
        <el-table
          border
          :data="orders">
          <el-table-column
            label="订单编号"
            :resizable="false"
            width="200">
            <template slot-scope="{row}">
              {{ row.orderNumber }}
            </template>
          </el-table-column>
          <el-table-column
            label="订单金额"
            prop="payAmount"></el-table-column>
          <el-table-column
            label="用户名"
            prop="userName"></el-table-column>
          <el-table-column label="下单时间">
            <template slot-scope="{row}">
              {{ row.createdTime }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          slot="footer"
          background
          :current-page="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="totalNum"
          @current-change="handleCurrentChange">
        </el-pagination>
      </template>
      <empty
        v-else
        tip="还没有订单信息" />
    </layout-card-wrap>
    <!-- <template slot="footer">
      <button-back />
    </template> -->
  </layout-main-inner>
</template>
<script type="text/ecmascript-6">
import moment from 'moment'
import SummaryList from './busi/summary.vue'
export default {
  name: 'WxappAgentDetail',
  components: { SummaryList },
  data() {
    return {
      loading: true,
      baseInfo: {},
      total: [],
      totalInfo: {},
      commission: [],
      commissionInfo: {},
      orders: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      },
      month: +Date.now()
    }
  },
  computed: {
    pickerOptions() {
      const ackTime = this.baseInfo.ackTime || 0
      return {
        disabledDate(time) {
          return +moment(time.getTime()).format('YYYYMM') < +moment(ackTime).format('YYYYMM') || +moment(time.getTime()).format('YYYYMM') > +moment(Date.now()).format('YYYYMM')
        }
      }
    },
    disabledDate() {
      const ackTime = this.baseInfo.ackTime || 0
      return +moment(this.month).format('YYYYMM') <= +moment(ackTime).format('YYYYMM')
    },
    disabledDate1() {
      return +moment(this.month).format('YYYYMM') >= +moment(Date.now()).format('YYYYMM')
    }
  },
  mounted() {
    this.getagent()
    this.getagentcommission()
    this.getagentorders()
    this.sumagentcommission()
  },
  methods: {
    getagent() {
      this.loading = true
      this.$store.dispatch('agent/getagent', {
        payload: this.$route.query,
        success: res => {
          this.loading = false
          this.baseInfo = {
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    onMonthChange() {
      this.getagentcommission()
      this.handleCurrentChange(1)
    },
    preMonth() {
      this.month = +moment(this.month).subtract(1, 'months')
      this.onMonthChange()
    },
    nextMonth() {
      this.month = +moment(this.month).add(1, 'months')
      this.onMonthChange()
    },
    getagentcommission() {
      this.loading = true
      this.$store.dispatch('agent/getagentcommission', {
        payload: {
          ...this.$route.query,
          month: moment(this.month).format('YYYYMM')
        },
        success: res => {
          this.loading = false
          this.commission = [
            {
              label: '业绩(元)',
              value: res.data.monthTotalAmount
            },
            {
              label: '订单数量',
              value: res.data.monthOrderCount || 0
            },
            {
              label: '收益(元)',
              value: res.data.commission
            }
          ]
          this.commissionInfo = res.data
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.getagentorders()
    },
    getagentorders() {
      this.loading = true
      this.$store.dispatch('agent/getagentorders', {
        payload: {
          ...this.$route.query,
          month: moment(this.month).format('YYYYMM'),
          ...this.config
        },
        success: res => {
          this.loading = false
          this.orders = res.data.records
          this.totalNum = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    sumagentcommission() {
      this.loading = true
      this.$store.dispatch('agent/sumagentcommission', {
        payload: this.$route.query,
        success: res => {
          this.loading = false
          this.totalInfo = res.data
          this.total = [
            {
              label: '总业绩(元)',
              value: res.data.totalOrderAmount
            },
            {
              label: '总收益(元)',
              value: res.data.totalCommission || 0
            },
            {
              label: '可提现收益(元)',
              value: res.data.cleaningAbleCommission
            },
            {
              label: '已提现收益(元)',
              value: res.data.cleanedCommission
            }
          ]
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang='stylus'>
.custom-class {
  .el-tag {
    margin-right: 10px;
  }
}
</style>
